/* global angular */

import addCourseTemplate from 'modals/addCourse/template.html';
import addCourseController from 'modals/addCourse/index';
import { orderBy } from 'lodash';

export default function($uibModal, $uibModalInstance, $log, coursesData) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  vm.selectCourse = function(type) {
    $uibModalInstance.close();
    const courses = angular.copy(vm.courses[type]);
    $uibModal
      .open({
        template: addCourseTemplate,
        backdrop: true,
        windowClass: 'modal',
        controller: addCourseController(courses, true)
      })
      .result.catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    const coursesObj = {};
    coursesData.forEach(course => {
      if (!coursesObj[course.delivery_method]) coursesObj[course.delivery_method] = [];
      coursesObj[course.delivery_method].push(course);
    });

    vm.courses = Object.keys(coursesObj).reduce((obj, key) => {
      obj[key] = orderBy(coursesObj[key], ['name'], ['asc']);
      return obj;
    }, {});

    vm.Queried = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/createEvent/controller.js